<template>
  <div class="application-analytics">
    <div class="row">
      <div class="col-sm-4">
        <vue-form ref="form"
          :options="{ permalink: 'applicationAnalytics' }"
          @load="refresh()">
          <div class="card-header" slot="title">
            <span class="fa fa-fw fa-chart-bar fa-lg"></span> Application Analytics Report
          </div>
          <template slot="actions">
            <div class="col-sm-8 offset-sm-4">
              <button type="button" class="btn btn-default" @click="refresh()">
                <span class="fa fa-fw fa-sync"></span> Refresh
              </button>
              <button type="button" class="btn btn-primary" @click="send()">
                <span class="fa fa-paper-plane fa-fw"></span> Send
              </button>
            </div>
          </template>
        </vue-form>
      </div>
      <div class="col-sm-8">
        <div class="card card-primary">
          <div class="card-header with-border">
            <span class="fa fa-fw fa-chart-bar"></span> Application Analytis Report
          </div>
          <div class="card-body">
            <chart :data="this.statusChart" title="New Applications - Status" ref="status"></chart>
            <hr class="dark"/>
            <chart :data="this.accountTypeChart" title="New Applications - Account Type" ref="types"></chart>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  hr.dark {
    border-color: #999;
  }
</style>

<script>
import VueForm from '@/components/Form'
import Api from '@/vuex/api'
import Chart from '@/components/Chart'

export default {
  name: 'ApplicationsReport',
  components: {
    Chart,
    VueForm
  },
  data () {
    return {
      rawData: {},
      statusLabels: [
        { label: 'Approved', data: [], color: '75, 192, 192' },
        { label: 'Declined', data: [], color: '255, 99, 132' },
        { label: 'Incomplete', data: [], color: '255, 206, 86' }
      ]
    }
  },
  computed: {
    accountTypeLabels () {
      let types = Object.values(this.rawData)
      let labels = []
      let pushedLabels = [
        'Approved', 'Declined', 'Incomplete'
      ]
      let colors = [
        '75, 192, 192',
        '255, 99, 132',
        '255, 206, 86',
        '153, 102, 255',
        '255, 159, 64',
        '54, 162, 235',
        '72, 223, 54',
        '97, 123, 199'
      ]
      for (let type of types) {
        for (let label in type) {
          if (!pushedLabels.includes(label)) {
            let index = label.charCodeAt(0) % colors.length
            let color = colors[index]
            colors.splice(index, 1)
            labels.push({ label, data: [], color })
            pushedLabels.push(label)
          }
        }
      }
      return labels
    },
    accountTypeChart () {
      return this.accountTypeLabels.map(({ label, color }, i) => {
        let labels = []
        let data = []
        for (let date in this.rawData) {
          let obj = this.rawData[date]
          if (!labels.includes(date)) labels.push(date)
          if (obj[label]) data.push(obj[label])
          else data.push(0)
        }
        return {
          label,
          color,
          data,
          labels
        }
      })
    },
    statusChart () {
      return this.statusLabels.map(({ label, color }, i) => {
        let labels = []
        let data = []
        for (let date in this.rawData) {
          let obj = this.rawData[date]
          if (!labels.includes(date)) labels.push(date)
          if (obj[label]) data.push(obj[label])
          else data.push(0)
        }
        return {
          label,
          color,
          data,
          labels
        }
      })
    }
  },
  methods: {
    async refresh () {
      let instance = new Api()
      let formData = this.$refs.form.serializeForm()
      this.rawData = await instance.getApplicationAnalytics(formData)
      await this.$nextTick()
      this.$refs.status.refresh()
      this.$refs.types.refresh()
    },
    send () {
      this.$refs.form.submitForm()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/ApplicationAnalytics.vue